export default "__VITE_ASSET__56OlCs3c__"